import React from 'react';
import styled from 'styled-components';

interface WorkInSyncProps {
    width?: number;
    height?: number;
}

const StyledSVG = styled.svg`
    display: block;
`;

export const PluginWorkInSync: React.FC<WorkInSyncProps> = ({ width = 56 }) => (
    <StyledSVG
        viewBox="0 0 100 100"
        width={width}
        height={width * 1}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="MVP---Plug-&amp;-Play-"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Plugin---Assets"
                transform="translate(-325.000000, -2293.000000)"
            >
                <rect
                    fill="#0C1B2B"
                    x="0"
                    y="0"
                    width="1440"
                    height="3108"
                ></rect>
                <g
                    id="icn/USP/WorkInSync"
                    transform="translate(325.000000, 2282.000000)"
                >
                    <path
                        d="M50,20.23 L50.5,23.1389874 L90.8,23.14 L91.3,96.33 L9.16,96.83 L8.66,56.09 L1,56.09 L0.5,20.73 L50,20.23 Z"
                        id="Combined-Shape"
                        stroke="#3F5365"
                    ></path>
                    <ellipse
                        id="Oval"
                        fill="#32CBCB"
                        cx="5.61"
                        cy="27.975"
                        rx="1.53"
                        ry="1.455"
                    ></ellipse>
                    <ellipse
                        id="Oval-Copy"
                        fill="#32CBCB"
                        cx="5.61"
                        cy="34.765"
                        rx="1.53"
                        ry="1.455"
                    ></ellipse>
                    <ellipse
                        id="Oval-Copy-2"
                        fill="#32CBCB"
                        cx="5.61"
                        cy="41.555"
                        rx="1.53"
                        ry="1.455"
                    ></ellipse>
                    <ellipse
                        id="Oval-Copy-3"
                        fill="#32CBCB"
                        cx="5.61"
                        cy="48.345"
                        rx="1.53"
                        ry="1.455"
                    ></ellipse>
                    <rect
                        id="Rectangle-Copy-18"
                        fill="#3F5365"
                        transform="translate(49.470000, 89.570000) scale(1, -1) translate(-49.470000, -89.570000) "
                        x="38.76"
                        y="88.6"
                        width="21.42"
                        height="1.94"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-19"
                        fill="#3F5365"
                        x="68.34"
                        y="77.93"
                        width="14.28"
                        height="1.94"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-20"
                        fill="#3F5365"
                        x="42.84"
                        y="63.38"
                        width="21.42"
                        height="1.94"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-22"
                        fill="#3F5365"
                        x="27.54"
                        y="63.38"
                        width="5.1"
                        height="1.94"
                    ></rect>
                    <rect
                        id="Rectangle-Copy-21"
                        fill="#3F5365"
                        x="61.2"
                        y="45.92"
                        width="21.42"
                        height="1.94"
                    ></rect>
                    <line
                        x1="12.75"
                        y1="27.975"
                        x2="16.83"
                        y2="27.975"
                        id="Line-8"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="19.89"
                        y1="27.975"
                        x2="43.35"
                        y2="27.975"
                        id="Line-8-Copy-6"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="12.75"
                        y1="34.765"
                        x2="21.93"
                        y2="34.765"
                        id="Line-8-Copy"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="24.99"
                        y1="34.765"
                        x2="43.35"
                        y2="34.765"
                        id="Line-8-Copy-4"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="12.75"
                        y1="41.555"
                        x2="28.05"
                        y2="41.555"
                        id="Line-8-Copy-2"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="31.11"
                        y1="41.555"
                        x2="43.35"
                        y2="41.555"
                        id="Line-8-Copy-5"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <line
                        x1="12.75"
                        y1="48.345"
                        x2="43.35"
                        y2="48.345"
                        id="Line-8-Copy-3"
                        stroke="#32CBCB"
                        strokeLinecap="round"
                    ></line>
                    <rect
                        id="Rectangle"
                        stroke="#3F5365"
                        x="8.66"
                        y="56.12"
                        width="14.3"
                        height="40.71"
                        rx="1"
                    ></rect>
                    <rect
                        id="Rectangle-Copy"
                        stroke="#3F5365"
                        x="50.48"
                        y="23.14"
                        width="40.82"
                        height="4.82"
                        rx="1"
                    ></rect>
                    <rect
                        id="Rectangle"
                        stroke="#ADB7BF"
                        x="0.5"
                        y="20.23"
                        width="50"
                        height="35.86"
                        rx="1"
                    ></rect>
                    <g
                        id="Group-20-Copy"
                        transform="translate(35.445454, 70.062390) rotate(-180.000000) translate(-35.445454, -70.062390) translate(10.455454, 47.752390)"
                        stroke="#ADB7BF"
                        strokeLinecap="round"
                    >
                        <polyline
                            id="Path-8"
                            transform="translate(3.118620, 14.755504) rotate(65.000000) translate(-3.118620, -14.755504) "
                            points="0.161379192 13.3708723 2.98654186 16.2558423 6.0758611 13.2551655"
                        ></polyline>
                        <path
                            d="M43.5184671,4.81130158 C25.4067497,5.16562661 10.4370646,20.617353 10.0827396,39.3236984"
                            id="Oval"
                            transform="translate(26.800603, 22.067500) rotate(65.000000) translate(-26.800603, -22.067500) "
                        ></path>
                    </g>
                    <g
                        id="Group-20"
                        transform="translate(29.723227, 0.954310)"
                        stroke="#ADB7BF"
                        strokeLinecap="round"
                    >
                        <polyline
                            id="Path-8"
                            transform="translate(3.118620, 14.755504) rotate(65.000000) translate(-3.118620, -14.755504) "
                            points="0.161379192 13.3708723 2.98654186 16.2558423 6.0758611 13.2551655"
                        ></polyline>
                        <path
                            d="M43.5184671,4.81130158 C25.4067497,5.16562661 10.4370646,20.617353 10.0827396,39.3236984"
                            id="Oval"
                            transform="translate(26.800603, 22.067500) rotate(65.000000) translate(-26.800603, -22.067500) "
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </StyledSVG>
);

export default PluginWorkInSync;
